import React from "react";
import { StyleSheet, View, Text, TouchableOpacity } from "react-native";
import { globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import withLiveData from "../../../common/withLiveData";
import {
  currencyConverter,
  formatPL,
  isMobile,
} from "../../../utils/commonMethods";
import { RUPEE_ICON } from "../../../utils/constants";
import {contest_smiley, contest_trophy, smile_coin, smile_coin_white} from "../../../utils/images";
import TimerComp from "../../../commonComponents/TimerComp";
import FastImage from "../../../common/FastImage";
import ParticipantsBlock from "./ParticipantsBlock";
import FormTextLabel from "../../../commonComponents/FormTextLabel";

const ContestCard = ({ isLiveSelected, data, timerExpireCallback }) => {
  return (
    <View>
      <View style={styles.cardContainer}>
        <View style={{ justifyContent: "space-between" }}>
          {/*<View style={styles.upperRow}>*/}
          {/*  {isLiveSelected && (*/}
          {/*    <ParticipantsBlock*/}
          {/*      participants_no={data?.number_of_participants}*/}
          {/*    />*/}
          {/*  )}*/}
          {/*  <Text*/}
          {/*    style={[*/}
          {/*      globalFontStyle.appFontSubHeading,*/}
          {/*      { color: Colors.black, flexWrap: "wrap", flex: 1 },*/}
          {/*    ]}*/}
          {/*    numberOfLines={2}*/}
          {/*  >*/}
          {/*    {data?.title}*/}
          {/*  </Text>*/}
          {/*</View>*/}

          <View style={styles.bottomRow}>
            <View style={{ ...styles.upperDetailsRow, marginBottom: 0 }}>
              <View style={{ flex: 1 }}>
                <Text
                  style={[
                    globalFontStyle.appFontHeading,
                    {
                      color: Colors.black,
                      flexWrap: "wrap",
                      flex: 1,
                      paddingRight: 30,
                    },
                  ]}
                  numberOfLines={2}
                >
                  {data?.title}
                </Text>
              </View>
              {isLiveSelected ? (
                <View style={{ alignItems: "center" }}>
                  {isLiveSelected && (
                    <FormTextLabel
                      labelStyles={[
                        globalFontStyle.appFontSubText,
                        {
                          color: Colors.lightgrey,
                          textAlign: "right",
                          paddingBottom: 5,
                        },
                      ]}
                      label={"Entry Fee"}
                    />
                  )}
                  <View style={[styles.cardBtn,
                    data?.entry_fee == 0 && {
                      backgroundColor: Colors.orange,
                    },
                    data?.is_participant && {
                      backgroundColor: Colors.tradexBlue,
                    },
                  ]}>
                    {!data?.is_participant && data?.entry_fee !== 0 && (<FastImage
                        style={{width: 13, height: 13, marginRight: 5}}
                        source={smile_coin()}
                    />)}
                    <FormTextLabel
                        labelStyles={[
                          globalFontStyle.appFontSubText,
                          {color: Colors.bgWhite,},
                        ]}
                        label={!data?.is_participant
                            ? data?.entry_fee == 0
                                ? "FREE"
                                : data?.entry_fee
                            : "Joined"}
                    />
                  </View>
                </View>
              ) : (
                <FormTextLabel
                  labelStyles={[globalFontStyle.appFontSubText, styles.cardBtnClosed]}

                  label={"Check Details"}
                />
              )}
            </View>
          </View>
        </View>
        {isLiveSelected ? (
          <TimerComp
            start_time={data?.start_time}
            end_time={data?.end_time}
            isHome={"contestDetails"}
            customStyle={styles.timerStyle}
            type={data?.contest_type}
            participant={data?.number_of_participants}
            timerExpireCallback={timerExpireCallback}
            // percentage={data?.winner_percentage}
          />
        ) : (
          <View
            style={[
              styles.status,
              data?.prize > 0 ? { backgroundColor: "#E7FFF2" } : {},
            ]}
          >
            <FastImage
              style={{ width: 15, height: 15, marginRight: 8 }}
              source={data?.prize > 0 ? contest_trophy() : contest_smiley()}
            />
            <FormTextLabel
              labelStyles={{
                ...globalFontStyle.appFontSubText,
                color: data?.prize > 0 ? Colors.green : Colors.black,
              }}
              label={data?.prize > 0
                  ? "Congratulations! You have won "
                  : "Chins up! Roll it up again"}
              rest={{prize: data?.prize ? parseInt(data?.prize) : data?.prize}}
            />
          </View>
        )}
      </View>
    </View>
  );
};

export default ContestCard;

const styles = StyleSheet.create({
  volStyle: {
    width: 15,
    height: 15,
    marginRight: 5,
  },
  cardContainer: {
    borderColor: Colors.borderColor,
    paddingHorizontal: 0,
    paddingTop: 15,
    paddingBottom: 15,
    borderRadius: 8,
    borderWidth: 0.75,
    //elevation: 2,
    marginTop: isMobile() ? 15 : 20,
  },
  upperRow: {
    marginBottom: 0,
    paddingHorizontal: 15,
    backgroundColor: Colors.grey3,
    marginTop: -15,
    paddingVertical: 15,
    borderTopRightRadius: 8,
    borderTopLeftRadius: 8,
  },
  bottomRow: {
    paddingHorizontal: 15,
    paddingTop: 0,
  },
  cardBtn: {
    backgroundColor: Colors.black,
    borderRadius: 8,
    width: 65,
    paddingVertical: 10,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  cardBtnClosed: {
    backgroundColor: Colors.bgWhite,
    borderRadius: 8,
    paddingHorizontal: 15,
    paddingVertical: 10,
    textAlign: "center",
    color: Colors.black,
    borderColor: Colors.black,
    borderWidth: 1,
  },
  status: {
    marginTop: 15,
    marginBottom: -15,
    marginHorizontal: 0,
    backgroundColor: "#E9E9E9",
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingVertical: 10,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingHorizontal: 15,
  },
  upperDetailsRow: {
    flexDirection: "row",
    flex: 1,
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 5,
  },
  timerStyle: {
    marginTop: 15,
    marginBottom: -15,
  },
});
